import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Material UI
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import TriggerInputItem from 'installations/assets/scenarios/TriggerInputItem';

const ScenarioLogExecInputTrigger = ({ execInputTrigger, device }) => (
  <div>
    <div className="row m-0">
      <LocalizedMessage id="info.scenarioExecInputTrigger" />
    </div>
    <div className="row m-0">
      <div className="col-12">
        <TriggerInputItem
          inputTrigger={execInputTrigger}
          device={device}
        />
      </div>
    </div>
  </div>
);

ScenarioLogExecInputTrigger.propTypes = {
  execInputTrigger: PropTypes.string.isRequired,
  device: deviceDataShape.isRequired,
};

module.exports = ScenarioLogExecInputTrigger;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/logs/ScenarioLogExecInputTrigger.js